module.exports = __webpack_public_path__ + "img/logo-brighter.904af542.png";